export default __webpack_public_path__ + "static/media/no_implement.f26523bb.png";